module.exports = __webpack_public_path__ + "img/unlock.4798b9b3.svg";